const map = {
	"./Lyon, Parc de la Tete d'Or 1.jpg": 5476,
	"./Lyon.jpg": 5023,
	"./Marseille, Porte d'Aix.jpg": 9570,
	"./Nice, Fontaine du Soleil.jpg": 4947,
	"./Nice, Promenade des Anglais.jpg": 4648,
	"./Paris, Eiffel Tower.jpg": 3530,
	"./Paris, Louvre.jpg": 6149,
	"./Paris, Tuileries Garden.jpg": 3323
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5511;